"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNavItemElements = void 0;
var react_1 = __importDefault(require("react"));
var __1 = require("../");
var components_1 = require("../../components");
/**
 * Takes an array of FlexibleNavItems and returns and array of
 * RouterNavLink, GKNavLink, and/or GKNavItem components
 *
 * @param navItems An array of NavItemType
 * @param isCollapsed If true, returns shortLabel if provided
 */
var getNavItemElements = function (navItems, isCollapsed) {
    return navItems.map(function (item, index) {
        var content = null;
        var passthruProps = {};
        if ((0, __1.isRouterNavTarget)(item)) {
            var to = item.to, icon = item.icon, shortLabel = item.shortLabel, label = item.label, badge = item.badge, badgeColor = item.badgeColor, onClick = item.onClick, pass = __rest(item, ["to", "icon", "shortLabel", "label", "badge", "badgeColor", "onClick"]);
            passthruProps = __assign({}, pass);
            content = (react_1.default.createElement(components_1.GKRouterNavLink, { to: to, className: "cursor-pointer", onClick: onClick },
                icon && react_1.default.createElement(components_1.GKIcon, { name: icon }),
                react_1.default.createElement("span", { className: "label" }, isCollapsed && shortLabel ? shortLabel : label),
                badge && (react_1.default.createElement(components_1.GKBadge, { color: badgeColor !== null && badgeColor !== void 0 ? badgeColor : "primary", pill: true }, badge))));
        }
        else if ((0, __1.isAnchorNavTarget)(item)) {
            var href = item.href, active = item.active, icon = item.icon, shortLabel = item.shortLabel, label = item.label, badge = item.badge, badgeColor = item.badgeColor, target = item.target, onClick = item.onClick, pass = __rest(item, ["href", "active", "icon", "shortLabel", "label", "badge", "badgeColor", "target", "onClick"]);
            passthruProps = __assign({}, pass);
            content = (react_1.default.createElement(components_1.GKNavLink, { href: href, active: active, className: "cursor-pointer", onClick: onClick, target: target !== null && target !== void 0 ? target : "_blank" },
                icon && react_1.default.createElement(components_1.GKIcon, { name: icon }),
                react_1.default.createElement("span", { className: "label" }, isCollapsed && shortLabel ? shortLabel : label),
                badge && (react_1.default.createElement(components_1.GKBadge, { color: badgeColor !== null && badgeColor !== void 0 ? badgeColor : "primary", pill: true }, badge))));
        }
        else {
            content = item;
        }
        return (react_1.default.createElement(components_1.GKNavItem, __assign({ key: "navItem-" + index }, passthruProps), content));
    });
};
exports.getNavItemElements = getNavItemElements;
